var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportChartContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63158 21.3421L5 24.9011V14.6842H8.63158M14.6842 19.1147L12.7837 17.4926L11.0526 19.0905V9.84211H14.6842M20.7368 17.1053L17.1053 20.7368V5H20.7368M24.1384 16.8753L21.9474 14.6842H28V20.7368L25.8332 18.57L17.1053 27.2253L12.9047 23.5695L8.32895 28H5L12.8321 20.3253L17.1053 23.9326",
    fill: "var(--report-widget-icon-stroke-dark)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportChartContentIcon);
export default __webpack_public_path__ + "static/media/report-chart-content-icon.30059682754111dca06dbe12301d3a95.svg";
export { ForwardRef as ReactComponent };